module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/instagram-3b783156ca7544490590faef7f770549.svg&quot;;"